import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { getLinkLtik } from 'constants/LTIData';
import classes from './BtnShop.module.css';

const url = window.location.pathname.split('/');

const BtnShop = () => {
  const { t } = useTranslation(['course']);
  const dataCourse = useSelector(state => state.courseInfo);
  const userInfo = useSelector(state => state.userInfo);
  const dataAcademy = useSelector(state => state.academyInfo);
  const [nextLesson, setNextLesson] = useState(0);
  const [nextActivity, setNextActivity] = useState('f');

  useEffect(() => {
    if (dataCourse.lessonsCourse.separators) {
      dataCourse.lessonsCourse.separators.map(separator => {
        separator.lessons.map(lesson => {
          setNextLesson(lesson.idVideo);
        });
      });
    }
    if (dataCourse.lessonsCourse.lessons) {
      dataCourse.lessonsCourse.lessons.map(lesson => {
        setNextLesson(lesson.idVideo);
      });
    }
    if (dataCourse.userAditionalTrack.nextTrack) {
      setNextActivity(
        dataCourse.userAditionalTrack.nextTrack.activity
      );
    }
  }, [dataCourse]);

  return (
    <>
      {userInfo.data.nombre ? (
        dataCourse.missingActivities.length > 0 ? (
          <>
            {dataCourse.accessCourse ? (
              <Button
                component={Link}
                to={
                  getLinkLtik()
                    ? `/${nextActivity}/${dataCourse.data.idLista}/${
                        dataCourse.userAditionalTrack.nextTrack
                          .userTrack
                      }/?ltik=${getLinkLtik()}`
                    : url[2] === 'a'
                    ? `/a/${nextActivity}/${dataCourse.data.idLista}/${dataCourse.userAditionalTrack.nextTrack.userTrack}`
                    : url[2] === 'course'
                    ? `/course/${nextActivity}/${dataCourse.data.idLista}/${dataCourse.userAditionalTrack.nextTrack.userTrack}`
                    : `/${nextActivity}/${dataCourse.data.idLista}/${dataCourse.userAditionalTrack.nextTrack.userTrack}`
                }
                className={
                  dataCourse.accessCourse
                    ? classes.shopAccessBtn
                    : classes.shopBtn
                }
              >
                {t('continue_course')}
              </Button>
            ) : (
              <>
                <p className={classes.specificProductPrice}>
                  {dataCourse.aditionalData.currencySymbol || '$'}{' '}
                  {dataCourse.aditionalData.monto.toFixed(2)}{' '}
                  {dataCourse.aditionalData.currency}
                </p>
                <Button
                  component="a"
                  href={`${process.env.REACT_APP_BASE_URL_PAGOS_MAYAHII}/cart/checkout/academy/course/${dataCourse.data.idEmisor}/${dataCourse.data.shortNameEmisor}/${dataCourse.data.idLista}`}
                  className={classes.shopBtn}
                >
                  <ShoppingCartIcon /> {t('continue_shopping')}
                </Button>
              </>
            )}
          </>
        ) : (
          <p className={classes.endCourseText}>
            {t('finished_course')}
          </p>
        )
      ) : dataAcademy.data.productType === 1 ? (
        <Button
          component={Link}
          to={
            getLinkLtik()
              ? `/f/${
                  dataCourse.data.idLista
                }/${nextLesson}/?ltik=${getLinkLtik()}`
              : url[2] === 'a'
              ? `/a/f/${dataCourse.data.idLista}/${nextLesson}`
              : url[2] === 'course'
              ? `/course/f/${dataCourse.data.idLista}/${nextLesson}`
              : `/f/${dataCourse.data.idLista}/${nextLesson}`
          }
          className={classes.shopBtn}
        >
          {t('continue_course')}
        </Button>
      ) : (
        dataCourse.aditionalData && (
          <>
            <p className={classes.specificProductPrice}>
              {dataCourse.aditionalData.currencySymbol || '$'}{' '}
              {dataCourse.aditionalData.monto &&
                dataCourse.aditionalData.monto.toFixed(2)}{' '}
              {dataCourse.aditionalData.currency}
            </p>
            <Button
              component="a"
              href={`${process.env.REACT_APP_BASE_URL_PAGOS_MAYAHII}/cart/checkout/academy/course/${dataCourse.data.idEmisor}/${dataCourse.data.shortNameEmisor}/${dataCourse.data.idLista}`}
              className={classes.shopBtn}
            >
              <ShoppingCartIcon /> {t('continue_shopping')}
            </Button>
          </>
        )
      )}
    </>
  );
};

export default BtnShop;
